'use client'

import { Button, useDocumentInfo } from '@payloadcms/ui'
import React from 'react'

const SkillTreeLinkButton: React.FC = () => {
  const { id, docPermissions } = useDocumentInfo()

  // Generate the skill tree URL based on the document ID
  const skillTreeUrl = id ? `${process.env.NEXT_PUBLIC_ST_FE_URL}/${id}` : null

  const handleClick = () => {
    if (skillTreeUrl) {
      window.open(skillTreeUrl, '_blank', 'noopener,noreferrer')
    }
  }

  // Show message if document is not saved yet
  if (!id) {
    return (
      <div
        style={{
          margin: '16px 0',
          padding: '12px',
          backgroundColor: '#f5f5f5',
          borderRadius: '4px',
        }}
      >
        <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
          💡 Save the skill tree first to generate the link
        </p>
      </div>
    )
  }

  // Show message if environment variable is not set
  if (!process.env.NEXT_PUBLIC_ST_FE_URL) {
    return (
      <div
        style={{ margin: '16px 0', padding: '12px', backgroundColor: '#fee', borderRadius: '4px' }}
      >
        <p style={{ color: '#c33', fontSize: '14px', margin: 0 }}>
          ⚠️ NEXT_PUBLIC_ST_FE_URL environment variable is not configured
        </p>
      </div>
    )
  }

  return (
    <Button buttonStyle="primary" size="large" onClick={handleClick}>
      Open Builder
    </Button>
  )
}

export default SkillTreeLinkButton
